{
  "title": "СӘТТІЛІК ДӨҢГЕЛЕГІ",
  "description": "Күн сайын сәтіңді сына!",
  "available": "Бүгінгі тегін мүмкіндік дайын!",
  "spin": "🎡 АЙНАЛДЫРУ",
  "spinning": "Дөңгелек айналып жатыр...",
  "winTitle": "Құттықтаймыз!",
  "win": "Сіз {{amount}} AZN бонус ұтып алдыңыз!",
  "used": "🎁 Бүгінгі мүмкіндікті пайдаландыңыз! Ертең қайта келіңіз!",
  "homeCta": "Дөңгелекті басып, сәтіңізді сынаңыз",
  "homeUsed": "Ертең қайта келіңіз!",
  "ribbonReady": "СӘТІҢДІ СЫНА",
  "ribbonUsed": "ЕРТЕҢ ҚАЙТА КЕЛ",
  "hubSpin": "АЙНАЛДЫР",
  "sheetHint": "Дөңгелекті басып, сәтіңізді сынаңыз",
  "winAmount": "{{amount}} AZN ҰТТЫҢЫЗ!",
  "closeResult": "Жабу",
  "demoBadge": "Көрнекі демо — нақты бонус әлі белсенді емес",
  "demoWinNote": "Бұл тек көрнекі нәтиже. Бонус балансына кредит жасалмады.",
  "testBadge": "САЙТ ТЕСТІ — TEST BONUS, шығарылмайды",
  "testWinNote": "{{amount}} AZN TEST BONUS есептелді. Бұл қаражат шығарылмайды және нақты балансқа қосылмайды.",
  "testBalance": "Тест бонус",
  "testLedger": "TEST BONUS (шығарылмайды)",
  "testNotWithdrawable": "Тест қаражатын шығаруға болмайды",
  "testExpires": "Тест мерзімі: {{when}}",
  "testPrize": "Тест жүлде: {{amount}} AZN",
  "mute": "Дыбысты өшіру",
  "unmute": "Дыбысты қосу",
  "close": "Жабу",
  "openAria": "VBB сәттілік дөңгелегін ашу",
  "spinFailed": "Айналдыру басталмады. Сәл кейінірек қайта көріңіз.",
  "wageringTitle": "Бонус отыгрышы",
  "bonusBalance": "Бонус балансы",
  "wageringMultiplier": "Талап",
  "wageringMultiplierValue": "{{count}}x",
  "wageringTarget": "Отыгрыш талабы",
  "wageringCompleted": "Орындалды",
  "wageringRemaining": "Қалды",
  "bonusStatus": "Бонус мәртебесі",
  "withdrawalEligibility": "Шығару",
  "bonusNotWithdrawable": "Бонусты конвертация мақұлданғанға дейін шығаруға болмайды",
  "loginRequiredBadge": "Login required for real bonus",
  "loginRequired": "Please sign in."
}
